import { useState, type InputHTMLAttributes } from 'react';
import { lerCampoNumerico, textoDoCampoNumerico } from '../lib/campoNumerico';

/**
 * Um campo de número que deixa a pessoa DIGITAR.
 *
 * Existe por um defeito real (dono, 17/08/2026): "o campo de colocar o valor
 * na venda não está permitindo nem , nem .". Os campos eram controlados pelo
 * NÚMERO — a cada tecla o valor virava número e era reescrito na tela. Como
 * `paraNumero('12,')` devolve null (e é certo que devolva: "12," não é um
 * número), digitar a vírgula zerava o campo.
 *
 * Aqui o TEXTO manda enquanto se digita, e o número volta a comandar no blur.
 * Estado intermediário ("12,") não reporta nada ao pai: o valor anterior fica
 * de pé até o número se formar. Campo vazio reporta `null` — aí a intenção de
 * apagar é clara.
 *
 * Quem usa decide o que fazer com o `null`: preço trata como zero, quantidade
 * ignora (não existe item de zero unidades).
 */
export default function CampoNumero({
  valor, onValor, onBlur, ...resto
}: {
  valor: number | null;
  onValor: (n: number | null) => void;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'onChange' | 'type'>) {
  const [digitado, setDigitado] = useState<string | null>(null);

  return (
    <input
      {...resto}
      inputMode="decimal"
      value={textoDoCampoNumerico(digitado, valor)}
      onChange={(e) => {
        const texto = e.target.value;
        setDigitado(texto);
        const leitura = lerCampoNumerico(texto);
        if (leitura.tipo === 'numero') onValor(leitura.valor);
        else if (leitura.tipo === 'vazio') onValor(null);
        // 'incompleto' não reporta: é o "12," a caminho de "12,50".
      }}
      onBlur={(e) => {
        // Solta o texto: a partir daqui o número canônico volta a mandar, e o
        // que não formou número some da tela.
        setDigitado(null);
        onBlur?.(e);
      }}
    />
  );
}
